import appManager from 'AppManager';
import { ContinueWatchingItem } from 'Utils/models/ContinueWatchingItem';
import { Device } from 'DeviceUtils';

export const PAGE_BY = Device.isTabletOrWeb ? 20 : 18;

export class PageItem {
    constructor(data) {
        this.type = data.type;
        this.data = data;
        this.carouselData = {};
    }

    getUpperCaseTitle() {
        return this.data.label.toUpperCase();
    }

    getCarouselData() {
        return this.carouselData;
    }

    downloadCarouselData = async (index) => {
        try {
            this.data.playlistId = this.data.playlistId.replace(/limit=(\d+)/, `limit=${PAGE_BY}`);
            const { items } = await appManager.getPlaylistItems(this.data);
            if (items) {
                const dataType = PageItem.getCarouselDataType(items, this.data.playlistId);
                this.carouselData = {
                    type: this.type,
                    dataType,
                    key: `page-item-${this.type}-${this.data.id}`,
                    testId: `page-item-${this.type}-${index}`,
                    title: this.getUpperCaseTitle(),
                    items: PageItem.parseItemsByDataType(items, dataType),
                    updateOnPageFocus: this.shouldUpdateOnPageFocus(dataType)
                };
            }
        } catch (error) {
            console.log(error);
        }
    };

    static getCarouselDataType = (items, playlistId) => {
        if (playlistId.includes('continue-watching')) return 'continue-watching';
        return items[0]?.modelType || 'unknown';
    };

    static parseItemsByDataType = (items, dataType) =>
        items.map((item) => {
            if (dataType === 'continue-watching') {
                return new ContinueWatchingItem(item);
            }

            return item;
        });

    shouldUpdateOnPageFocus = (dataType) => dataType === 'continue-watching';
}
